import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static values = {
    menuId: Number
  }

  connect() {
    this.modal = document.getElementById('shareMenuModal')
  }

  async openModal(event) {
    event.preventDefault()

    const menuId = this.menuIdValue
    if (!menuId) return

    // Mostrar modal con loading
    const modalBody = document.getElementById('shareMenuModalBody')
    modalBody.innerHTML = `
      <div class="text-center py-4">
        <div class="spinner-border text-success" role="status">
          <span class="sr-only">Cargando...</span>
        </div>
        <p class="mt-2 text-muted">Generando enlace...</p>
      </div>
    `

    $(this.modal).modal('show')

    try {
      const response = await fetch(`/custom_menus/${menuId}/share`, {
        method: 'POST',
        headers: {
          'X-CSRF-Token': document.querySelector('meta[name="csrf-token"]').content,
          'Accept': 'text/html'
        }
      })

      if (response.ok) {
        const html = await response.text()
        modalBody.innerHTML = html
        modalBody.querySelectorAll('script').forEach(oldScript => {
          const newScript = document.createElement('script')
          newScript.textContent = oldScript.textContent
          oldScript.parentNode.replaceChild(newScript, oldScript)
        })
      } else {
        modalBody.innerHTML = `
          <div class="alert alert-danger">
            Error al generar el enlace. Por favor intente nuevamente.
          </div>
        `
      }
    } catch (error) {
      console.error('Error:', error)
      modalBody.innerHTML = `
        <div class="alert alert-danger">
          Error de conexión. Por favor intente nuevamente.
        </div>
      `
    }
  }

  copyUrl(event) {
    event.preventDefault()

    const urlInput = document.getElementById('shareUrl')
    if (!urlInput) return

    urlInput.select()
    urlInput.setSelectionRange(0, 99999)
    document.execCommand('copy')

    // Feedback visual
    const btn = event.currentTarget
    const originalHtml = btn.innerHTML
    btn.innerHTML = '<i class="fas fa-check"></i> Copiado!'
    btn.classList.replace('btn-success', 'btn-secondary')

    setTimeout(() => {
      btn.innerHTML = originalHtml
      btn.classList.replace('btn-secondary', 'btn-success')
    }, 2000)
  }
}
